import React from 'react';
import styled from '@emotion/native';
import { FieldTitle } from '@/shared/styles/styledComponents/styledComponents';
import StaticInput from '@/shared/components/StaticInput';
import { largeInputBorderStyle } from '@/shared/styles/styledComponents/editProfileForm';
import { green } from '@/shared/styles/colors';

interface Props {
  bio: string;
  setBio: (value: string) => void;
  sizingDetails: string;
  setSizingDetails: (value: string) => void;
  height: string;
  setHeight: (value: string) => void;
}

const AboutYou = ({
  bio,
  setBio,
  sizingDetails,
  setSizingDetails,
  height,
  setHeight,
}: Props) => {
  return (
    <Container>
      <FieldTitle marginBottom={24} fontSize={16}>
        Bio (optional)
      </FieldTitle>
      <InputWrapper>
        <StaticInput
          labelText="BIO"
          value={bio}
          onChange={(e) => setBio(e.nativeEvent.text)}
          placeholderText="Share a brief bio about yourself for stylists to get to know you better."
          multiline
          showLabel
          outlineStyle={largeInputBorderStyle}
          contentStyle={{
            paddingHorizontal: 18,
            borderRadius: 8,
            paddingBottom: 16,
            paddingTop: 16,
          }}
          customStyles={{
            height: 120,
            minHeight: 120,
            justifyContent: 'flex-start',
            borderRadius: 8,
            color: green,
            marginBottom: 0,
          }}
        />
      </InputWrapper>

      <FieldTitle marginBottom={24} fontSize={16} style={{ marginTop: 24 }}>
        Sizing Details (optional)
      </FieldTitle>
      <InputWrapper>
        <StaticInput
          labelText="SIZING"
          value={sizingDetails}
          onChange={(e) => setSizingDetails(e.nativeEvent.text)}
          placeholderText="Enter your ideal sizing information (pant, shirt, dress etc)"
          multiline
          showLabel
          outlineStyle={largeInputBorderStyle}
          contentStyle={{
            paddingHorizontal: 18,
            borderRadius: 8,
            paddingBottom: 16,
            paddingTop: 16,
          }}
          customStyles={{
            height: 120,
            minHeight: 120,
            justifyContent: 'flex-start',
            borderRadius: 8,
            color: green,
            marginBottom: 0,
          }}
        />
      </InputWrapper>

      <FieldTitle marginBottom={24} fontSize={16} style={{ marginTop: 24 }}>
        Height (optional)
      </FieldTitle>
      <InputWrapper>
        <StaticInput
          labelText="HEIGHT"
          value={height}
          onChange={(e) => setHeight(e.nativeEvent.text)}
          placeholderText={`Enter your height (e.g., 5' 3")`}
          showLabel
          customStyles={{
            color: green,
            marginBottom: 0,
          }}
        />
      </InputWrapper>
    </Container>
  );
};

const Container = styled.View({
  width: '100%',
  paddingTop: 16,
});

const InputWrapper = styled.View({
  position: 'relative',
  width: '100%',
});

export default AboutYou;
